// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put } from "./api_client";
import { FleetDefaults, IFleetDefaults } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getForOrganization(organizationId?: string): ApiResult<FleetDefaults> {
	return get<IFleetDefaults>(`/api/fleetdefaults/${ organizationId }`).then(result => result === undefined ? undefined :  new FleetDefaults(result));
}

export async function save(update: FleetDefaults): ApiResult<FleetDefaults> {
	return put<IFleetDefaults>(`/api/fleetdefaults`, update).then(result => result === undefined ? undefined :  new FleetDefaults(result));
}
